/**
 * Lenz — Helpers para la product page.
 *
 * v6: Re-ubicar el widget de upsell PickyStory para que aparezca JUSTO ARRIBA
 *     del botón "Agregar al carrito", dentro de la columna .product-info,
 *     no después del producto entero.
 *
 * Ubicación target en el DOM:
 *   .product
 *     └─ safe-sticky.product-info
 *          └─ ...bloques (title, price, accordions, etc.)
 *          └─ .product-info__buy-buttons   ← INSERTAMOS EL SLOT JUSTO ANTES
 *               └─ .shopify-product-form
 *                    └─ buy-buttons
 *                         └─ button "Agregar al carrito"
 *
 * No tocamos el HTML de PickyStory ni su JS — solo movemos el contenedor
 * raíz a otro slot del DOM. Los listeners internos siguen funcionando porque
 * jQuery delega o el código usa selectores absolutos.
 */

(function () {
  'use strict';

  function findSlotTarget() {
    // Preferido: insertar como HERMANO del bloque buy-buttons en la columna
    // info. Si el botón ya fue envuelto en .lenz-atc-wa-row (fila ATC+WA de
    // mobile/tablet), subimos al wrapper: el slot debe ser hijo directo del
    // grid .product-info, nunca quedar DENTRO de esa fila.
    var buyButtonsBlock = document.querySelector('.product-info__buy-buttons');
    if (buyButtonsBlock) {
      var beforeEl = buyButtonsBlock.closest('.lenz-atc-wa-row') || buyButtonsBlock;
      if (beforeEl.parentElement) {
        return {
          parent: beforeEl.parentElement,
          before: beforeEl,
        };
      }
    }
    // Fallback 1: si no encontramos esa clase, usamos buy-buttons mismo y
    // metemos el slot antes del shopify-product-form que la contiene.
    var form = document.querySelector('.shopify-product-form');
    if (form && form.parentElement) {
      return {
        parent: form.parentElement,
        before: form,
      };
    }
    // Fallback 2: cualquier botón "Agregar al carrito" — subimos al primer
    // wrapper razonable y metemos el slot antes.
    var btn = document.querySelector('buy-buttons');
    if (btn && btn.parentElement) {
      return {
        parent: btn.parentElement,
        before: btn,
      };
    }
    return null;
  }

  function moveWidget() {
    // PickyStory monta DOS tipos de widgets distintos según la config del producto:
    //   1. lb-product-page-cross-sell-ew (.ppcse) — bundle "Compra junto con"
    //   2. lb-upsell-product-page-addon — recomendaciones "También podrías necesitar"
    // Movemos AMBOS si existen (uno o ambos pueden estar presentes).
    var widgets = [
      document.querySelector('lb-product-page-cross-sell-ew'),
      document.querySelector('.ppcse:not([data-lenz-moved="1"]), .ppcse-m:not([data-lenz-moved="1"])'),
      document.querySelector('lb-upsell-product-page-addon'),
    ].filter(function (w) {
      return w && w.dataset.lenzMoved !== '1';
    });
    if (!widgets.length) return false;

    var product = document.querySelector('.product');
    if (!product) return false;

    var target = findSlotTarget();
    if (!target) return false;

    // Reusar slot existente si ya está colocado donde queremos.
    var slot = target.parent.querySelector(':scope > .lenz-upsell-slot');
    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'lenz-upsell-slot lenz-upsell-slot--inline';
      target.parent.insertBefore(slot, target.before);
    }

    // .product-info es un grid que ordena sus bloques con `order`. El order del
    // slot (3, igual que buy-buttons) vive en lenz-product-page-v12.css — CSS
    // estático, sin carrera: getComputedStyle aquí devolvía "0" si el CSS del
    // theme aún no aplicaba, congelando el slot arriba del todo.
    widgets.forEach(function (widget) {
      if (widget.parentElement !== slot) {
        slot.appendChild(widget);
      }
      widget.dataset.lenzMoved = '1';
    });
    product.classList.add('product--has-lenz-upsell');
    // syncWhatsAppRow (product-info.liquid) pina gridRow del botón/WhatsApp con
    // índices calculados ANTES de que exista el slot; si Selleasy llega tarde,
    // el botón queda pineado bajo el FBT y se tapa. Escucha `resize`: lo
    // disparamos para que re-calcule con el slot ya insertado.
    window.dispatchEvent(new Event('resize'));
    return true;
  }

  function init() {
    if (moveWidget()) return;
    // El widget puede aparecer después (la app es async). Observamos cambios
    // en el body hasta que lo encontremos. Una vez movido, desconectamos.
    var observer = new MutationObserver(function () {
      if (moveWidget()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Fail-safe: deja de observar tras 15s para no consumir CPU eternamente.
    setTimeout(function () { observer.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ─────────────────────────────────────────────────────────────
   Lenz — ETA en mobile: mover debajo de los métodos de pago.

   En MOBILE puro (< 768px) el ETA se mueve desde .lenz-product-left
   (donde vive en el HTML) a .product-info, insertándolo DESPUÉS
   del último bloque de pagos (.product-info__liquid) y antes del
   HR separador. Así el orden visual queda:
     galería → info (precio, kits, ATC, WhatsApp, Mercado Pago)
             → ETA → HR → descripción

   En TABLET (768-999) y DESKTOP (≥ 1000px) el ETA se queda en su
   posición original en .lenz-product-left, debajo de la galería.
   Esto coincide con el deseo del merchant: en tablet la columna
   izquierda muestra galería + ETA, y la derecha (o el bloque que
   le sigue en single-column) muestra info + ATC.
   ──────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  // < 768px = mobile real. >= 768px (tablet + desktop) deja el ETA
  // debajo de la galería en .lenz-product-left.
  var BREAKPOINT = 768;

  function getEta() { return document.getElementById('lenz-product-eta-card'); }

  // Posición canónica en DESKTOP/TABLET: dentro de .lenz-product-left,
  // como último hijo (después de la galería y el botón Ver 3D).
  function getDesktopTarget() {
    var left = document.querySelector('.lenz-product-left');
    if (!left) return null;
    return { parent: left, before: null }; // null = appendChild
  }

  // Posición en MOBILE: insertar justo antes del HR separador en .product-info.
  // Así el orden visual: galería → info → pagos → ETA → HR → descripción.
  function getMobileTarget() {
    var hr = document.querySelector('.product-info__separator');
    if (hr && hr.parentElement) return { parent: hr.parentElement, before: hr };
    var desc = document.querySelector('.product-info__description');
    if (desc && desc.parentElement) return { parent: desc.parentElement, before: desc };
    return null;
  }

  function moveEtaTo(target) {
    var eta = getEta();
    if (!eta || !target) return;
    // Si ya está donde debe (mismo padre y misma posición), no hacer nada
    if (eta.parentElement === target.parent) {
      if (target.before == null && eta === target.parent.lastElementChild) return;
      if (target.before != null && eta.nextElementSibling === target.before) return;
    }
    if (target.before) {
      target.parent.insertBefore(eta, target.before);
    } else {
      target.parent.appendChild(eta);
    }
  }

  function applyLayout() {
    var target = window.innerWidth < BREAKPOINT ? getMobileTarget() : getDesktopTarget();
    moveEtaTo(target);
  }

  function init() {
    var eta = getEta();
    var hr = document.querySelector('.product-info__separator');
    var left = document.querySelector('.lenz-product-left');
    if (eta && (hr || left)) { applyLayout(); return; }
    var obs = new MutationObserver(function () {
      if (getEta() && (document.querySelector('.product-info__separator') || document.querySelector('.lenz-product-left'))) {
        obs.disconnect();
        applyLayout();
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 10000);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyLayout, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-verificar después de load por si la galería 3D u otros JS hacen
  // reordenamiento que mueva el ETA.
  window.addEventListener('load', function () {
    setTimeout(applyLayout, 200);
  });
})();

/* ─────────────────────────────────────────────────────────────
   Lenz — En tablet (768-1199px) envolver "Agregar al carrito" y el
   banner de WhatsApp en un contenedor flex para que aparezcan en una
   sola línea (lado a lado).

   El banner de WhatsApp viene de un Shopify App Block externo (NTA-Woo
   Products) que se renderiza como hermano de .product-info__buy-buttons
   dentro de safe-sticky.product-info. Para ponerlos en una sola fila
   sin tocar el theme/app, los envolvemos en un <div class="lenz-atc-wa-row">
   y al CSS le decimos display:flex en tablet.

   En desktop (≥1200), des-envolvemos para devolver
   cada bloque a su posición natural en el flujo del documento.

   v2: Extendido a mobile (<768px) también — en mobile se usa display:grid
   de 2 columnas vía CSS (.lenz-atc-wa-row en @media max-width:767px).
   ──────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  // Ahora aplica en mobile + tablet (0-1199px). Solo en desktop (≥1200px)
  // des-envolvemos — en desktop el layout es 2 columnas y el ATC/WA
  // se ven bien cada uno en su fila.
  var WRAP_MAX = 1199;
  var ROW_CLASS = 'lenz-atc-wa-row';

  function getBuyButtons() {
    return document.querySelector('safe-sticky.product-info .product-info__buy-buttons, .product-info .product-info__buy-buttons');
  }

  // El bloque de WhatsApp es el shopify-app-block que sigue al buy-buttons
  // y contiene el botón wa__button del app seedgrow_whatsapp_chat.
  function getWhatsAppBlock(buyBtns) {
    if (!buyBtns) return null;
    var sib = buyBtns.nextElementSibling;
    while (sib) {
      if (sib.classList && sib.classList.contains('shopify-app-block')) {
        if (sib.querySelector('a.wa__button, a[href*="wa.me"]')) return sib;
      }
      sib = sib.nextElementSibling;
    }
    return null;
  }

  function shouldWrap() {
    return window.innerWidth <= WRAP_MAX;
  }

  function wrap() {
    var btn = getBuyButtons();
    if (!btn) return false;
    if (btn.parentElement && btn.parentElement.classList.contains(ROW_CLASS)) return true;
    var wa = getWhatsAppBlock(btn);
    if (!wa) return false;

    var row = document.createElement('div');
    row.className = ROW_CLASS;
    btn.parentNode.insertBefore(row, btn);
    row.appendChild(btn);
    row.appendChild(wa);
    btn.style.gridRow = '';
    wa.style.gridRow = '';
    return true;
  }

  function unwrap() {
    var row = document.querySelector('.' + ROW_CLASS);
    if (!row) return;
    var parent = row.parentNode;
    while (row.firstChild) parent.insertBefore(row.firstChild, row);
    parent.removeChild(row);
  }

  function applyLayout() {
    if (shouldWrap()) { wrap(); } else { unwrap(); }
  }

  function init() {
    var tries = 0;
    function attempt() {
      tries++;
      applyLayout();
      if (!shouldWrap()) return;
      if (document.querySelector('.' + ROW_CLASS)) return;
      if (tries < 60) setTimeout(attempt, 500);
    }
    attempt();

    var observer = new MutationObserver(function () {
      if (shouldWrap() && !document.querySelector('.' + ROW_CLASS)) {
        if (wrap()) observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 35000);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyLayout, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ─────────────────────────────────────────────────────────────
   Lenz — Header mobile (<740px): vendor / SKU / título / precio
   arriba de la galería.

   Estrategia primaria: el bloque .lenz-mobile-header se renderiza
   en Liquid (main-product.liquid) antes de .lenz-product-left.
   Estrategia secundaria (fallback): si el bloque Liquid no está en
   el DOM (cache de Shopify sirviendo versión anterior), este IIFE
   lo crea dinámicamente desde los datos de product-info.

   Solo actúa en mobile estricto (<740px).
   ──────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var MOBILE_MAX = 739; // <740px = mobile estricto

  function run() {
    if (window.innerWidth > MOBILE_MAX) return;

    // Si el bloque Liquid ya está en el DOM, nada que hacer
    if (document.querySelector('.lenz-mobile-header')) return;

    var info   = document.querySelector('safe-sticky.product-info');
    var galería = document.querySelector('.lenz-product-left');
    if (!galería || !galería.parentElement) return;

    var dest = galería.parentElement;  // .product

    // Buscar elementos en todo el DOM
    var vendor = document.querySelector('.product-info__vendor');
    var title  = document.querySelector('.product-info__title');
    var price  = info ? info.querySelector('.product-info__price') : null;

    if (!title && !price) return;

    // Crear el wrapper .lenz-mobile-header
    var header = document.createElement('div');
    header.className = 'lenz-mobile-header';
    dest.insertBefore(header, galería);

    // Mover o clonar elementos dentro del wrapper
    // vendor y title pueden estar ya en .product (movidos por IIFE anterior)
    // o en safe-sticky (si IIFE anterior no corrió)
    function adoptEl(el, wrapperClass, isClone) {
      if (!el) return;
      if (isClone) {
        // Clonar el contenido para no romper reactividad de Shopify
        var div = document.createElement('div');
        div.className = wrapperClass;
        div.innerHTML = el.innerHTML;
        header.appendChild(div);
        el.style.display = 'none'; // ocultar original
      } else {
        // Mover el elemento físico y aplicar clase
        el.classList.add(wrapperClass);
        header.appendChild(el);
      }
    }

    adoptEl(vendor, 'lenz-mobile-header__vendor', true);
    adoptEl(title,  'lenz-mobile-header__title',  true);

    // El precio siempre se mueve (no clona) desde product-info
    if (price) {
      var pDiv = document.createElement('div');
      pDiv.className = 'lenz-mobile-header__price';
      pDiv.innerHTML = price.innerHTML;
      header.appendChild(pDiv);
      price.style.display = 'none';
    }
  }

  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Re-chequear en load (por si product-info cargó tarde)
  window.addEventListener('load', function() {
    if (!document.querySelector('.lenz-mobile-header') && window.innerWidth <= MOBILE_MAX) {
      run();
    }
  });
})();

/* ─────────────────────────────────────────────────────────────
   Lenz — Badge de descuento dinámico al cambiar variante.

   El custom element on-sale-badge del tema usa el string
   discountBadge ("-@@") al cambiar variante. Lo parcheamos
   para que use la misma lógica condicional del Liquid:
     ≥ 10% → "13% Dcto."
     < 10% → "S/ 20 menos"
   ──────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  function formatSavings(compareAtPrice, price) {
    var savingsCents = compareAtPrice - price;
    var pct = Math.round(savingsCents * 100 / compareAtPrice);
    if (pct >= 10) {
      return pct + '% Dcto.';
    }
    // Ahorro en soles — usar formatMoney si disponible, fallback manual
    var amount = savingsCents / 100;
    var formatted;
    try {
      formatted = window.Shopify && window.Shopify.formatMoney
        ? window.Shopify.formatMoney(savingsCents, 'S/ {{amount_no_decimals}}')
        : 'S/ ' + Math.round(amount);
    } catch (e) {
      formatted = 'S/ ' + Math.round(amount);
    }
    return formatted + ' menos';
  }

  // Esperar a que on-sale-badge esté definido y parchear connectedCallback
  function patchOnSaleBadge() {
    var proto = window.customElements.get('on-sale-badge');
    if (!proto) return false;
    var origProto = proto.prototype;
    // Parchear el listener de variant:change via observer de eventos
    document.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      document.querySelectorAll('on-sale-badge[form]').forEach(function (badge) {
        if (variant.compare_at_price > variant.price) {
          badge.hidden = false;
          badge.textContent = event.detail.product && event.detail.product.price_varies
            ? badge.textContent  // precio variable: no tocar
            : formatSavings(variant.compare_at_price, variant.price);
        } else {
          badge.hidden = true;
        }
      });
    }, true); // capture para correr antes que el listener original
    return true;
  }

  // on-sale-badge puede no estar definido aún al cargar este script
  if (!patchOnSaleBadge()) {
    var checkInterval = setInterval(function () {
      if (patchOnSaleBadge()) clearInterval(checkInterval);
    }, 50);
    setTimeout(function () { clearInterval(checkInterval); }, 5000);
  }
})();

/* ─────────────────────────────────────────────────────────────
   Lenz — Preservar SVG del botón "Agregar al carrito" tras variant:change.

   BUG DEL THEME (theme.js línea ~2854-2863): al cambiar variante ejecuta:
       const addToCartButtonText = addToCartButton.firstElementChild;
       addToCartButtonText.innerHTML = "Agregar al carrito";
   El firstElementChild es <div class="text-with-icon"> que contiene
   <svg> + texto. Al asignar innerHTML solo con el texto, BORRA el SVG
   y la clase del wrapper.

   FIX: usamos MutationObserver sobre el botón ATC para detectar cambios
   en el primer div hijo y restaurar el SVG inmediatamente (síncrono,
   sin setTimeout) — esto elimina el parpadeo visible.

   Estrategia: cuando el theme cambia .innerHTML, el MutationObserver se
   dispara en el siguiente microtask (antes del próximo paint). Al añadir
   el SVG ahí, el browser pinta directamente el botón completo, sin
   intermedio sin-SVG.
   ──────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  // SVG inline del icono cart del tema (extraído de buy-buttons.liquid).
  var ATC_CART_SVG = '<svg role="presentation" stroke-width="1.6" focusable="false" width="18" height="18" class="icon icon-cart" viewBox="0 0 22 22">' +
    '<path d="M14.666 7.333a3.666 3.666 0 1 1-7.333 0M3.33 6.785l-.642 7.7c-.137 1.654-.206 2.48.073 3.119a2.75 2.75 0 0 0 1.21 1.314c.612.332 1.442.332 3.102.332h7.853c1.66 0 2.49 0 3.103-.332a2.75 2.75 0 0 0 1.21-1.314c.279-.638.21-1.465.072-3.12l-.642-7.7c-.118-1.423-.178-2.134-.493-2.673A2.75 2.75 0 0 0 16.99 3.02c-.563-.269-1.277-.269-2.705-.269h-6.57c-1.428 0-2.142 0-2.705.27A2.75 2.75 0 0 0 3.823 4.11c-.315.539-.374 1.25-.493 2.674Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>' +
    '</svg>';

  // Flag para evitar loops infinitos (cuando NOSOTROS modificamos el div,
  // el MutationObserver se dispararía de nuevo).
  var isOurMutation = false;

  function restoreSvgInDiv(div, btn) {
    if (isOurMutation) return;
    if (!div) return;
    // Si está disabled (sold out), el theme oculta el icono — respetar
    if (btn.disabled) return;
    // Si ya tiene SVG, OK
    if (div.querySelector('svg')) return;
    // Restaurar el wrapper completo: clase + SVG + texto preservado
    var currentText = div.textContent.trim();
    isOurMutation = true;
    div.className = 'text-with-icon justify-center';
    div.innerHTML = ATC_CART_SVG + currentText;
    // Resetear el flag en el próximo microtask
    Promise.resolve().then(function () { isOurMutation = false; });
  }

  function observeButton(btn) {
    if (btn.dataset.lenzSvgObserved === '1') return;
    btn.dataset.lenzSvgObserved = '1';

    // Restaurar SVG ya mismo (estado inicial puede estar mal)
    var firstDiv = btn.querySelector(':scope > div');
    restoreSvgInDiv(firstDiv, btn);

    // MutationObserver: detecta cuando el theme reemplaza el contenido del div
    var observer = new MutationObserver(function () {
      var div = btn.querySelector(':scope > div');
      restoreSvgInDiv(div, btn);
    });
    // Observar cambios en el botón completo: hijos nuevos/quitados Y
    // subtree para detectar cambios dentro del div hijo (innerHTML del theme).
    observer.observe(btn, {
      childList: true,
      subtree: true,
      characterData: false,
    });
  }

  function observeAllButtons() {
    var buttons = document.querySelectorAll(
      'buy-buttons button[type="submit"][is="custom-button"]'
    );
    buttons.forEach(observeButton);
  }

  function init() {
    observeAllButtons();
    // Re-observar si aparecen nuevos botones (ej. sticky bar de Add to Cart)
    var globalObs = new MutationObserver(function () { observeAllButtons(); });
    globalObs.observe(document.body, { childList: true, subtree: true });
    // Detener después de 30s
    setTimeout(function () { globalObs.disconnect(); }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ─────────────────────────────────────────────────────────────
   Lenz — Slide 3D inline en mobile: TOMA DE CONTROL TOTAL del iframe.

   PROBLEMA: el HTML del snippet product-gallery.liquid está cacheado
   por Shopify por horas. El script inline del snippet también queda
   cacheado, así que cambios en ese código no se reflejan inmediatamente.

   SOLUCIÓN: este IIFE en lenz-product-page-v12.js (que SÍ se actualiza
   inmediatamente vía CDN) toma el control completo del slide 3D:
   1. Lee el slide del DOM (sin importar qué atributo data tenga)
   2. Construye la URL del viewer con minimal=1&v=13&mobile=1
   3. Crea el iframe INMEDIATAMENTE al cargar (sin lazy load)
   4. Traduce el hint a español si está en inglés

   El pre-fetch del HTML del visor se hace via <link rel=prefetch> en
   main-product.liquid (en el <head>), así el browser empieza a descargar
   el HTML del visor en paralelo con el resto de la página. Cuando este
   IIFE crea el iframe, el HTML ya está en cache → carga instantánea.

   Solo aplica en mobile estricto (<740px). En desktop el slide 3D está
   display:none y no se monta — el usuario interactúa con "VER 3D" otro
   sistema (botón thumbnail que abre modal).
   ──────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  if (window.innerWidth >= 740) return;

  var VIEWER_VERSION = "22";

  function buildViewerUrl(rawUrl) {
    if (!rawUrl) return null;
    try {
      var u = new URL(rawUrl);
      u.searchParams.set('minimal', '1');
      u.searchParams.set('v', VIEWER_VERSION);
      // En mobile añadir mobile=1 → overlays más agresivos en el visor
      if (window.innerWidth < 740) {
        u.searchParams.set('mobile', '1');
      }
      // NOTA: v17 — removido cache buster cb=Date.now(). El parámetro v=17
      // ya invalida el cache cuando bumpemos la versión, y permite que el
      // browser cachee la respuesta HTML entre visitas (mejor performance).
      return u.toString();
    } catch (e) {
      return rawUrl;
    }
  }

  function readSlideSrc(slide) {
    // Probar todos los atributos posibles (el HTML puede estar cacheado con el viejo)
    var candidates = [
      slide.dataset && slide.dataset.viewerUrl,
      slide.getAttribute('data-viewer-url'),
      slide.getAttribute('data-lenz-3d-src'),
      slide.getAttribute('data-lenz3d-src'),
    ];
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i]) return candidates[i];
    }
    return null;
  }

  function setupSlide3D() {
    var slide = document.querySelector('.lenz-3d-slide');
    if (!slide) return false;
    if (slide.dataset.lenzSetupDone === '1') return true;

    var rawUrl = readSlideSrc(slide);
    if (!rawUrl) return false;

    var src = buildViewerUrl(rawUrl);
    var container = slide.querySelector('.lenz-3d-slide__iframe-container');
    var skeleton  = slide.querySelector('.lenz-3d-slide__skeleton');
    var hintText  = slide.querySelector('.lenz-3d-slide__hint-text');

    // Crear container si no existe (el HTML viejo puede no tenerlo)
    if (!container) {
      container = document.createElement('div');
      container.className = 'lenz-3d-slide__iframe-container';
      container.style.cssText = 'position:absolute;inset:0;';
      slide.appendChild(container);
    }

    // Traducir el hint si está en inglés
    if (hintText && hintText.textContent.trim() === 'Hold and drag to rotate') {
      hintText.textContent = 'Arrastra para rotar';
    }

    // Fondo blanco al slide (mover el overlay gris a las otras imágenes — ver CSS)
    slide.style.background = '#f5f5f5';

    // Crear y montar el visor inmediatamente (model-viewer o iframe)
    if (!container.querySelector('iframe') && !container.querySelector('model-viewer')) {
      // v20.4: el auto-switch al slide 3D debe ocurrir SIEMPRE en mobile,
      // en cualquier variant (requerimiento del usuario). El check anterior
      // de "scrollLeft > 30 → return" hacía que NO funcionara cuando el
      // usuario llegaba con ?variant=X (porque theme.js scrolleó a la
      // imagen del variant durante carga).
      //
      // Pero queremos respetar la INTERACCIÓN MANUAL del usuario: si
      // tocan/scrollean la galería ANTES que el modelo 3D termine de
      // cargar, NO hacer auto-switch (sería disruptivo).
      var autoScrollDone = false;
      var userInteracted = false;

      // Marcar interacción manual del usuario (touch/click en el carousel)
      var carouselForListener = slide.parentElement;
      if (carouselForListener) {
        var markUser = function () { userInteracted = true; };
        carouselForListener.addEventListener('touchstart', markUser, { passive: true, once: true });
        carouselForListener.addEventListener('pointerdown', function (e) {
          // Ignorar pointerdown sintéticos del propio scroll programático
          if (e.isTrusted) userInteracted = true;
        }, { passive: true, once: true });
      }

      function autoScrollToSlide3D() {
        if (autoScrollDone) return;
        autoScrollDone = true;
        var carousel = slide.parentElement;
        if (!carousel) return;
        // Respetar interacción manual del usuario
        if (userInteracted) return;
        // Setear flag para que backToFirst del snippet no interfiera
        window.__lenzAutoScrollAllowed = true;
        // Smooth scroll al slide 3D — funciona en cualquier variant
        try {
          slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        } catch (e) {
          carousel.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      }

      function hideSkeleton() {
        if (skeleton && skeleton.style.opacity !== '0') {
          skeleton.style.transition = 'opacity 0.3s ease';
          skeleton.style.opacity = '0';
          setTimeout(function() {
            if (skeleton.parentElement) skeleton.style.display = 'none';
          }, 400);
        }
        // v18: Marcar como "ready" para que arranque la animación del hint
        slide.classList.add('lenz-3d-slide--ready');
      }

      // ── Camino iframe (legacy / fallback) ────────────────────────────────
      function mountIframe() {
        if (container.querySelector('iframe') || container.querySelector('model-viewer')) return;
        var iframe = document.createElement('iframe');
        iframe.className = 'lenz-3d-slide__iframe';
        iframe.allow = 'autoplay; xr-spatial-tracking';
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('title', 'Vista 3D interactiva');
        // v20: iframe visible desde el inicio (opacity:1) — el usuario ve el
        // progress bar interno del visor 3D enseguida. El skeleton se hide:
        //   1. iframe.onload (~1-2s)  2. postMessage 'ready'  3. timeout 8s
        iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:none;background:#f5f5f5;opacity:1;';

        iframe.addEventListener('load', function() {
          setTimeout(hideSkeleton, 200);
          setTimeout(autoScrollToSlide3D, 4000);
        });

        window.addEventListener('message', function onMsg(e) {
          if (!e.data || typeof e.data !== 'object') return;
          var src_ = e.data.source;
          var type_ = e.data.type;
          if ((src_ === 'lenz3d-preload' || src_ === 'lenz3d-custom') && type_ === 'ready') {
            hideSkeleton();
            setTimeout(autoScrollToSlide3D, 350);
            window.removeEventListener('message', onMsg);
          }
        });

        setTimeout(hideSkeleton, 8000);

        // IMPORTANTE: appendChild ANTES de setear src — algunos browsers
        // (iOS Safari notablemente) no disparan el load event si el src se
        // setea antes de añadir el iframe al DOM.
        container.appendChild(iframe);
        iframe.src = src;
      }

      // ── Camino <model-viewer> (embeds con GLB AR) ───────────────────────
      // Render DIRECTO del GLB texturizado en metros: sin iframe, sin bundle
      // Vue (~530KB), orbit nativo con touch-action pan-y (el scroll vertical
      // de la página no se secuestra) y AR integrado (webxr/scene-viewer/
      // quick-look — el pill "Ver en tu espacio" llama activateAR()).
      // Los helpers __lenzMakeMv/__lenzLoadModelViewer los define el snippet
      // product-3d-viewer.liquid (inline, corre antes que este archivo).
      function mountModelViewer(st) {
        if (container.querySelector('iframe') || container.querySelector('model-viewer')) return;
        var mv = window.__lenzMakeMv(st, {
          className: 'lenz-mv--inline',
          mobile: true,
          css: 'position:absolute;inset:0;',
        });
        mv.addEventListener('load', function () {
          hideSkeleton();
          setTimeout(autoScrollToSlide3D, 350);
        }, { once: true });
        setTimeout(hideSkeleton, 8000);
        container.appendChild(mv);
      }

      // Decisión: el VISOR es el player original (iframe), que es el mismo
      // motor y los mismos assets que reviewthree, así que se ve idéntico
      // por construcción. El GLB/USDZ queda solo para AR, donde renderiza el
      // sistema operativo. Traducir el shader de Agnes a PBR nunca alcanzó
      // la fidelidad del original (ver product-3d-viewer.liquid, 2026-08-19).
      // Para volver a model-viewer: window.__lenzUseMvViewer = true.
      var decided = false;
      function decide(st) {
        if (decided) return;
        decided = true;
        // legacy -> iframe (fidelidad del player original); facade -> model-viewer
        var canMv = st && st.android && !st.legacy && window.__lenzMakeMv && window.__lenzLoadModelViewer;
        if (canMv) {
          window.__lenzLoadModelViewer()
            .then(function () { mountModelViewer(st); })
            .catch(function () { mountIframe(); });
        } else {
          mountIframe();
        }
      }
      if (window.__lenzArStatus && typeof window.__lenzArStatus.then === 'function') {
        window.__lenzArStatus.then(decide).catch(function () { decide(null); });
        setTimeout(function () { decide(null); }, 2500);
      } else {
        decide(null);
      }
    }

    // v18: marcar el slide como "interactuado" cuando el usuario toca el
    // iframe (o cualquier parte del slide). Esto oculta el hint
    // "Arrastra para rotar" inmediatamente. El CSS maneja el fade.
    var markInteracted = function() {
      slide.classList.add('lenz-3d-slide--interacting');
      slide.removeEventListener('touchstart', markInteracted);
      slide.removeEventListener('pointerdown', markInteracted);
      slide.removeEventListener('mousedown', markInteracted);
    };
    slide.addEventListener('touchstart', markInteracted, { passive: true });
    slide.addEventListener('pointerdown', markInteracted, { passive: true });
    slide.addEventListener('mousedown', markInteracted, { passive: true });

    slide.dataset.lenzSetupDone = '1';
    return true;
  }

  // Esperar al carousel y al slide
  function init() {
    if (setupSlide3D()) return;
    var obs = new MutationObserver(function() {
      if (setupSlide3D()) obs.disconnect();
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function() { obs.disconnect(); }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ─────────────────────────────────────────────────────────────
   Lenz — Fix variant:change scroll en TODOS los breakpoints.

   PROBLEMA: cuando el usuario cambia la variante (ej: elige otro Kit),
   el theme ejecuta:
     carousel.select(featured_media.position - 1)
   donde "position" es la posición de la imagen en el array product.media,
   asumiendo que coincide con el índice del slide en el DOM.

   PERO insertamos un slide 3D inline después del primer media en mobile
   Y en desktop (en desktop está display:none, pero sigue siendo hijo del
   carousel y cuenta en `this.items` del theme.js). Esto desfasa los
   índices a partir de la 2da imagen en +1, así el carousel scrollea al
   slide equivocado (uno antes del correcto).

   ADEMÁS: el slide 3D inline solo se renderiza si el producto tiene
   metafield lenz3d.embed_id. En productos sin 3D, este fix es no-op.

   FIX: escuchamos `variant:change` en bubbling phase (corre DESPUÉS del
   theme), buscamos el slide con `data-media-id="<featured_media.id>"`
   directamente (no por índice), y hacemos scroll con scrollTo nativo.
   Esto es robusto contra reordenamientos del DOM.

   IMPORTANTE: se aplica en TODOS los breakpoints porque el slide 3D
   existe en el DOM en todos (oculto via CSS en desktop pero presente).
   ──────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  function scrollToVariantMedia(event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || !variant.featured_media) return;
    var featuredMediaId = variant.featured_media.id;
    if (!featuredMediaId) return;

    // Solo aplicar si el producto tiene slide 3D inline (que es lo que
    // causa el desfase). Si no hay slide 3D, el theme ya scrollea bien.
    var slide3d = document.querySelector('.lenz-3d-slide');
    if (!slide3d) return;

    var carousel = document.querySelector('media-carousel');
    if (!carousel) return;

    // Esperar a que el theme ejecute primero su carousel.select (incorrecto),
    // luego corregimos al slide correcto identificándolo por data-media-id.
    setTimeout(function () {
      var targetSlide = carousel.querySelector(
        '.product-gallery__media[data-media-id="' + featuredMediaId + '"]'
      );
      if (!targetSlide) return;
      // Si el slide ya es el seleccionado, no hacer nada (evita scroll innecesario)
      var carouselRect = carousel.getBoundingClientRect();
      var slideRect = targetSlide.getBoundingClientRect();
      // Centrar el slide en el viewport del carousel (similar a slideAlign:center)
      // O alinear al inicio (slideAlign:start) según el modo
      var targetLeft = targetSlide.offsetLeft;
      // Tolerancia de 5px para evitar scroll si ya está cerca
      if (Math.abs(carousel.scrollLeft - targetLeft) < 5) return;
      carousel.scrollTo({ left: targetLeft, behavior: 'smooth' });
    }, 80);
  }

  function init() {
    document.addEventListener('variant:change', scrollToVariantMedia, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ─────────────────────────────────────────────────────────────
   Lenz — v20: Badge "3D" auto-hide cuando el slide 3D está activo.

   El badge "3D" inamovible aparece bottom-center sobre los dots
   en mobile. Cuando el usuario hace scroll al slide 3D, el badge
   se vuelve redundante (ya estás viendo el 3D). Lo escondemos
   añadiendo clase `product-gallery--lenz-3d-active` al wrapper
   <product-gallery> cuando detectamos que el slide 3D ocupa
   la mayor parte del viewport del carousel.

   Solo aplica en mobile <740px (en desktop el slide 3D no existe
   visible y el badge está display:none por CSS).
   ──────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  if (window.innerWidth >= 740) return;

  function setup() {
    var gallery = document.querySelector('product-gallery');
    var slide3d = document.querySelector('.lenz-3d-slide');
    var carousel = document.querySelector('media-carousel');
    if (!gallery || !slide3d || !carousel) return false;

    function updateActiveState() {
      var carouselRect = carousel.getBoundingClientRect();
      var slideRect = slide3d.getBoundingClientRect();
      // El slide 3D es "activo" si su centro está dentro del 50% central
      // del carousel viewport.
      var slideCenter = slideRect.left + slideRect.width / 2;
      var carouselCenter = carouselRect.left + carouselRect.width / 2;
      var threshold = carouselRect.width / 4; // 25% margen a cada lado
      var isActive = Math.abs(slideCenter - carouselCenter) < threshold;
      gallery.classList.toggle('product-gallery--lenz-3d-active', isActive);
    }

    // Escuchar scroll del carousel (debounced via rAF)
    var rafId = null;
    carousel.addEventListener('scroll', function () {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        updateActiveState();
      });
    }, { passive: true });

    // Update inicial
    updateActiveState();
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setup(); });
  } else {
    setup();
  }
  // Re-intentar si el DOM no estaba listo
  setTimeout(function () { setup(); }, 1500);
})();


/* ─────────────────────────────────────────────────────────────────────────
   Upsell "También podrías necesitar" — flechas para el scroll horizontal de
   una sola fila (desktop). En mobile el swipe ya funciona. El widget
   (PickyStory) hidrata async, así que esperamos al carrusel con polling.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  function buildArrow(dir, carousel) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lenz-upsell-arrow ' + (dir === 'next' ? 'lenz-upsell-next' : 'lenz-upsell-prev');
    b.setAttribute('aria-label', dir === 'next' ? 'Ver más productos recomendados' : 'Ver productos anteriores');
    var d = dir === 'next' ? 'm9 18 6-6-6-6' : 'm15 18-6-6 6-6';
    b.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>';
    b.addEventListener('click', function () {
      var card = carousel.querySelector('.lb-upsell-ppa-display-flex');
      var step = card ? Math.round(card.getBoundingClientRect().width) + 10 : 260;
      carousel.scrollBy({ left: dir === 'next' ? step : -step, behavior: 'smooth' });
    });
    return b;
  }

  function setup() {
    var slot = document.querySelector('.lenz-upsell-slot');
    var carousel = slot && slot.querySelector('.lb-upsell-ppa-grid-carousel');
    if (!slot || !carousel) return false;
    if (slot.querySelector('.lenz-upsell-arrow')) return true; // ya inyectadas

    if (getComputedStyle(slot).position === 'static') slot.style.position = 'relative';

    var prevBtn = buildArrow('prev', carousel);
    var nextBtn = buildArrow('next', carousel);
    slot.appendChild(prevBtn);
    slot.appendChild(nextBtn);

    function update() {
      // Centrar verticalmente las flechas sobre el carrusel (no sobre el título)
      var cy = carousel.offsetTop + carousel.clientHeight / 2;
      prevBtn.style.top = cy + 'px';
      nextBtn.style.top = cy + 'px';
      var maxScroll = carousel.scrollWidth - carousel.clientWidth;
      var hasOverflow = maxScroll > 4;
      var x = carousel.scrollLeft;
      prevBtn.style.display = (hasOverflow && x > 4) ? 'grid' : 'none';
      nextBtn.style.display = (hasOverflow && x < maxScroll - 4) ? 'grid' : 'none';
    }
    carousel.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
    // Re-evaluar tras posibles re-render del widget de PickyStory
    setTimeout(update, 600);
    setTimeout(update, 1800);
    return true;
  }

  function poll() {
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (setup() || tries > 40) clearInterval(iv);
    }, 400);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poll);
  } else {
    poll();
  }
})();


/* ─────────────────────────────────────────────────────────────────────────
   Quick-add (barra flotante "Agregar al carrito") — evitar choque con el
   widget de WhatsApp en tablet/desktop.

   El custom element <product-quick-add> togglea is-visible / is-half-start /
   is-half-end según el scroll. La regla :has() del theme solo cubre
   is-visible y no funciona en navegadores sin soporte de :has() (tablets
   antiguas). Aquí observamos su estado real y ponemos body.lenz-quickadd-on
   mientras esté visible (cualquier estado / opacidad > 0). El CSS asociado
   sube el WhatsApp para que no se solapen. Funciona en todos los navegadores.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  function isShown(qa) {
    if (qa.classList.contains('is-visible') ||
        qa.classList.contains('is-half-start') ||
        qa.classList.contains('is-half-end')) return true;
    var op = parseFloat(getComputedStyle(qa).opacity || '1');
    var vis = getComputedStyle(qa).visibility;
    return vis !== 'hidden' && op > 0.05;
  }
  function init() {
    var qa = document.querySelector('product-quick-add');
    if (!qa) return false;
    function sync() {
      document.body.classList.toggle('lenz-quickadd-on', isShown(qa));
    }
    try {
      var mo = new MutationObserver(sync);
      mo.observe(qa, { attributes: true, attributeFilter: ['class', 'style'] });
    } catch (e) {}
    // respaldo por si el observer no captura cambios de opacidad por transición
    window.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    sync();
    return true;
  }
  if (!init()) {
    var n = 0;
    var iv = setInterval(function () { if (init() || ++n > 40) clearInterval(iv); }, 300);
  }
})();

/* ─────────────────────────────────────────────────────────────────────────
   Feedback al añadir desde el upsell / quick-view de PickyStory.
   Problema: "Añadir al carrito" SÍ añade el producto, pero no abre el carrito
   ni da feedback claro → el usuario cree que no funcionó. Aquí, al detectar
   un clic en un botón de añadir del upsell/modal, vigilamos el carrito y, al
   confirmar el incremento, refrescamos y ABRIMOS el cart drawer del theme.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  /* Sincroniza la UI del carrito del theme con el carrito real tras un add de
     PickyStory (que mete el item por su propio AJAX y NO avisa al theme, dejando
     el contador del header en 0 → el usuario cree que "no funcionó").
     CLAVE: el contador del header (cart-count) SOLO se actualiza con el evento
     'cart:change' que traiga detail.cart; el theme cachea fetchCart en page-load,
     así que 'cart:refresh' por sí solo lee un carrito viejo y deja el badge en 0.
     Despachamos 'cart:change' (actualiza el badge del header + estado del drawer)
     y 'cart:refresh' (re-renderiza el contenido del cart drawer). NO forzamos el
     cierre del modal ni abrimos el drawer: PickyStory ya muestra su propio
     "Añadido con éxito" dentro del modal, y abrir el drawer lo dejaría detrás del
     modal (estado confuso). Con el badge del header actualizado el feedback es
     claro y estándar. */
  function broadcastCart(cart) {
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { cart: cart, baseEvent: 'lenz-upsell-add' }
      }));
    } catch (e) {}
  }
  function syncCart(freshCart) {
    // Emitimos 'cart:change' (actualiza el badge del header + estado del drawer)
    // y 'cart:refresh' (re-renderiza el contenido del drawer). Re-emitimos
    // 'cart:change' a 600/1500ms con el carrito re-consultado porque PickyStory,
    // al terminar su propio AJAX de add, re-sincroniza el header con su vista
    // cacheada (0) DESPUÉS de nosotros; re-emitir gana esa carrera y deja el badge
    // correcto. 'cart:change' es idempotente (solo fija el conteo), así que es
    // seguro repetirlo.
    broadcastCart(freshCart);
    try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
    [600, 1500].forEach(function (ms) {
      setTimeout(function () {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(broadcastCart).catch(function () {});
      }, ms);
    });
  }
  function isUpsellAddBtn(target) {
    var b = target && target.closest && target.closest('button, a, [class*="tot-btn"], [class*="add-to-cart"]');
    if (!b) return false;
    if (!b.closest('lb-upsell-product-page-addon, .ppcse-modal-wrap, .lb-upsell-modal-wrap, .lenz-upsell-slot, .ppcse, .ppcse-m')) return false;
    var t = (b.textContent || '').toLowerCase();
    var c = (b.className || '').toString().toLowerCase();
    return /a.adir al carrito|agregar al carrito|add to cart/.test(t) ||
           /tot-btn|prod-add|add-to-cart|ppcse-modal-form-control/.test(c);
  }
  document.addEventListener('click', function (e) {
    if (!isUpsellAddBtn(e.target)) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var before = c.item_count;
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c2) {
          if (c2.item_count > before) { clearInterval(iv); syncCart(c2); }
          else if (tries > 16) { clearInterval(iv); }
        }).catch(function () { if (tries > 16) clearInterval(iv); });
      }, 300);
    }).catch(function () {});
  }, true);
})();

/* ─────────────────────────────────────────────────────────────
   Lenz — Miniaturas CONTEXTUALES en los swatches del variant picker.

   PROBLEMA (reportado 2026-08-12, a6400): al cambiar la opción "Lente",
   las miniaturas de los botones de la OTRA opción ("Kit de accesorios")
   se quedaban con la imagen de la familia anterior. El theme NO
   re-renderiza el variant picker al cambiar variante (morpha precio/sku/
   galería, pero el picker persiste para no perder foco): los precios de
   los swatches ya se actualizan por JS (data-price-label), las imágenes
   no — hasta ahora.

   CÓMO: en `variant:change` (mismo patrón que el parche de on-sale-badge
   de arriba), para cada input de opción (name="option{N}", value=V) se
   busca la variante cuya opción N sea V y cuyas DEMÁS opciones coincidan
   con la selección actual; su featured_image reemplaza el src/srcset de
   la miniatura del swatch. Si esa combinación no existe o no tiene
   imagen, la miniatura se queda como está (mejor vieja que rota).

   El Liquid (variant-picker.liquid, 2026-08-12) rendea contextual en el
   primer paint; este módulo mantiene esa semántica en vivo. Los dos van
   en pareja: si se vuelve a "imagen estable" en Liquid, quitar esto.
   ───────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  function imageUrlAt(src, width) {
    try {
      var u = new URL(src, location.origin);
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) { return src; }
  }

  function updateSwatchImages(product, variant) {
    if (!product || !product.variants || !variant || !variant.options) return;
    var selected = variant.options; // ['Kit Básico', 'Lente 16-50mm II', ...]

    document.querySelectorAll('input[name^="option"][data-option-position], input[name^="option"]').forEach(function (input) {
      var m = (input.name || '').match(/^option(\d+)$/);
      if (!m) return;
      var optIndex = parseInt(m[1], 10) - 1;
      var value = input.value;
      if (optIndex < 0 || optIndex >= selected.length) return;

      // Variante objetivo: este valor en SU opción + la selección actual
      // en las demás.
      var target = null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var ok = true;
        for (var j = 0; j < selected.length; j++) {
          var want = j === optIndex ? value : selected[j];
          if (v.options[j] !== want) { ok = false; break; }
        }
        if (ok) { target = v; break; }
      }
      if (!target || !target.featured_image || !target.featured_image.src) return;

      // La miniatura vive en el label del input (block-swatch)
      var label = input.id ? document.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
      var img = label && label.querySelector('.block-swatch__variant-img img');
      if (!img) return;
      var src = target.featured_image.src;
      img.src = imageUrlAt(src, 80);
      img.srcset = imageUrlAt(src, 40) + ' 40w, ' + imageUrlAt(src, 80) + ' 80w';
    });
  }

  document.addEventListener('variant:change', function (event) {
    var d = event.detail || {};
    // microtask después del handler del theme, por si éste toca el picker
    setTimeout(function () { updateSwatchImages(d.product, d.variant); }, 0);
  }, false);
})();

/* ─────────────────────────────────────────────────────────────────────────
   Banner de cuotas: "Hasta 3 cuotas sin intereses de S/X, pagando con:".
   Es un bloque Liquid de templates/product.json que calcula el monto en el
   SERVIDOR con selected_or_first_available_variant, así que al cambiar de
   kit seguía mostrando la cuota de la variante inicial (R50 Kit Deluxe
   S/3,649 decía S/1,149.66, que es S/3,449 / 3). Aquí se recalcula en cada
   variant:change del form principal, con la misma cuenta que Liquid
   (divided_by entre enteros = floor), el número de cuotas que diga el propio
   texto y el mismo formato que ya pintó el servidor.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  function formatLike(sample, cents) {
    var prefix = (sample.match(/^[^\d]*/) || [''])[0];
    var decimals = /\.\d{2}\s*$/.test(sample) ? 2 : 0;
    return prefix + (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || typeof variant.price !== 'number') return;
    var info = event.target && event.target.closest ? event.target.closest('.product-info') : null;
    var cuotas = info && info.querySelector('.lenz-payment-cuotas');
    var amount = cuotas && cuotas.querySelector('strong');
    if (!amount) return;
    var m = (cuotas.textContent || '').match(/(\d+)\s*cuotas/i);
    var n = m ? parseInt(m[1], 10) : 3;
    if (!(n > 0)) return;
    amount.textContent = formatLike((amount.textContent || '').trim(), Math.floor(variant.price / n));
  });
})();
